module.exports = __webpack_public_path__ + "img/20190628161133QQ截图20190624162247.fccb31a5.png";